/* eslint-disable no-unused-expressions */
import { useMutation } from '@apollo/client';
import React, { useState } from 'react';

import { ADMIN_APPROVE_DOCUMENT } from '../../graphql/admin_mutations';
import ModalFormComp from '../ModalFormComp';
import StyledButton from '../StyledButton';
import useToast from '../../customHooks/useToast';
import PdfViewer from './PdfViewer';
import RolesAndPermissionGuard from '../RolesAndPermissionGuard';
import GifLoader from '../Loading/GifLoader';
// import RefreshingSticker from '../RefreshingSticker';
import FileSvg from '../../svgs/FileSvg';

import './ViewFile.scss';

interface IViewFile{
  file?:any;
  fileType?:any;
  handleClose?:any;
  payload?:any;
  handleShowReject?:any;
  loading?:boolean;
  loadData?: any;
  setUploadModal?:any;
  fetchKyc?:any;
  fetchUser?:any;
  viewDocumentType?:any;
  id?:any;
  hideActions?: boolean;
  provider?: string;
  canUpdatePermission?:string;
  canRejectPermission?:string;
  canAcceptPermission?:string;
}
const ViewFile = ({
  file, fileType, handleClose, payload,
  handleShowReject, loading, loadData,
  // setUploadModal,
  fetchKyc,
  viewDocumentType,
  fetchUser,
  id,
  hideActions,
  canAcceptPermission,
  // canUpdatePermission,
  canRejectPermission,
}:IViewFile) => {
  const Toast = useToast();
  const [approveDocument] = useMutation<
  { approveDocumentCa: any },
  any
>(ADMIN_APPROVE_DOCUMENT);

  const [ApproveLoading, setApproveLoading] = useState(false);
  const isIdentityPass = payload?.provider === 'IDENTITY_PASS';

  const handleAccept = async () => {
    try {
      setApproveLoading(true);
      const res = await approveDocument({
        variables: { id: payload?.id },
      });
      if (res?.data?.approveDocumentCa?.status === 200) {
        Toast.success(res?.data?.approveDocumentCa?.message);
        setApproveLoading(false);
        handleClose();
        viewDocumentType ? fetchUser?.({ variables: { id } }) : fetchKyc?.();
        return;
      }
      Toast.error(res?.data?.approveDocumentCa?.message);
    } catch (e) {
      if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
        Toast.error(e.graphQLErrors[0].message);
      } else {
        Toast.error('Something went wrong');
      }
    }
    setApproveLoading(false);
  };
  const [downloading, setDownloading] = React.useState(false);
  const downloadDoc = async (imgUrl: string, fileName) => {
    try {
      const result = await fetch(imgUrl);
      const blob = await result.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
    } catch (error) {
      window.open(imgUrl, '_blank');
    }
  };

  const download = async (url: any) => {
    if (!url) return;
    const fileName = `${payload?.documentType || 'file'}_${Date.now()}`;
    // Creating an anchor(a) tag of HTML
    await downloadDoc(url, fileName);
  };

  const handleDownload = async () => {
    if (downloading) return;
    setDownloading(true);
    const res = await loadData?.();
    if (res) await download(res);
    setDownloading(false);
  };
  const renderStatusIcon = payload?.status !== '1' && payload?.status !== '-1';

  return (
    <div>
      <ModalFormComp removeTitle closeModal={handleClose} modalType="file-viewer" cancleDivWidth="520px">
        <div>
          <div style={{
            height: 'fit-content', overflow: 'auto', display: 'flex', justifyContent: 'center', position: 'relative',
          }}
          >

            {loading ? <div className="loader-div"><GifLoader /></div> : (
              <div className="file-cover">

                {
                  fileType === 'image' ? <img style={{ marginBottom: '16px' }} src={file} alt="file" /> : fileType === 'pdf' ? <PdfViewer src={file} /> : <div className="svg-cover flexed-center"><FileSvg /></div>
                }
              </div>
            )}
          </div>
          <span className="doc-name">
            {payload?.documentType?.split?.('_')?.join(' ')?.toLowerCase()}
          </span>
          {(!hideActions && !isIdentityPass) && (
            <>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '20px',
              }}
              >
                {
                  renderStatusIcon && (
                  <RolesAndPermissionGuard permissionName={canAcceptPermission}>
                    <StyledButton name={ApproveLoading ? 'loading...' : 'Accept'} backgroundColor="#10B981" width="272px" height="31px" borderRadius="4px" color="white" fontSize="12px" onClick={handleAccept} disabled={!!ApproveLoading} />
                  </RolesAndPermissionGuard>
                  )

                }

              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
              }}
              >
                {
                  renderStatusIcon && (
                  <RolesAndPermissionGuard permissionName={canRejectPermission}>
                    <StyledButton name="Reject" backgroundColor="#F9E3E2" width="272px" height="31px" borderRadius="4px" color="#EF4444" fontSize="12px" onClick={handleShowReject} />
                  </RolesAndPermissionGuard>
                  )
                }

              </div>
              {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
                <RolesAndPermissionGuard permissionName={canUpdatePermission}>
                  <StyledButton
                    name="Update"
                    backgroundColor="black"
                    width="272px"
                    height="31px"
                    borderRadius="4px"
                    color="#FFF"
                    fontSize="12px"
                    onClick={() => {
                      setUploadModal?.(true);
                      handleClose();
                    }}
                  />
                </RolesAndPermissionGuard>

              </div> */}
            </>
          )}
          <RolesAndPermissionGuard permissionName="can-download-customer-document">
            <span onClick={handleDownload} className="download-btn">
              {downloading ? 'Downloading...' : 'Download'}
            </span>
          </RolesAndPermissionGuard>
        </div>

      </ModalFormComp>
    </div>
  );
};
export default ViewFile;
